module.exports = __webpack_public_path__ + "media/images/story/typo/declarationCute-1bf2b4dd8b306d1193a8c929c2dd837f.svg";